
export enum UserPermission {
  NONE = 'none',
  PROFILE = 'profile',
  USER_MANAGEMENT = 'user-management',
  SMARTICLE_CONTROLLING = 'smarticle-controlling',
  MESSAGES = 'admin_messages',
  VIDEO_HELP = 'video-help',
  ONBOARDING_WIZARD = 'onboarding-wizard',
  DEFAULT_TRANSLATIONS = 'default-translations',
  DASHBOARD = 'dashboard',
  WEBSITE_MODULES = 'website-modules'
}

export interface Profile {
  name: string;
  email: string;
  permissions: UserPermission[];
}
